import { render, staticRenderFns } from "./ClearingManagementDetails1.vue?vue&type=template&id=13dec15a&scoped=true"
import script from "./ClearingManagementDetails1.vue?vue&type=script&lang=js"
export * from "./ClearingManagementDetails1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13dec15a",
  null
  
)

export default component.exports